// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared admin UI patterns — import via index.css */

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--color-navy);
  margin: 0 0 24px 0;
}

.page-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.page-controls .search-bar,
.page-controls .search-input {
  flex: 1 1 200px;
  min-width: 180px;
  max-width: 320px;
}

.table-container {
  background-color: #fff;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  padding: 14px 20px;
  text-align: left;
  border-bottom: 1px solid var(--color-border);
}

.data-table th {
  font-weight: 600;
  color: var(--color-navy);
  background-color: #fafafa;
  white-space: nowrap;
}

.data-table td {
  color: #374151;
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.data-table td.text-nowrap {
  white-space: nowrap;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

/* Consistent table action icons (react-icons) */
.table-action-buttons {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.table-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: #fff;
  color: var(--color-navy);
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s, border-color 0.15s;
  padding: 0;
}

.table-action-btn svg {
  width: 18px;
  height: 18px;
}

.table-action-btn:hover {
  background-color: #f2f7ff;
  border-color: #c7d8f5;
}

.table-action-btn.danger:hover {
  background-color: #fee2e2;
  border-color: #fca5a5;
  color: #b91c1c;
}

.table-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.table-action-btn.featured {
  color: #f59e0b;
  border-color: #fcd34d;
  background-color: #fffbeb;
}

.table-action-btn.featured svg {
  fill: #f59e0b;
}

.coming-soon-control {
  opacity: 0.55;
  cursor: not-allowed;
  pointer-events: none;
  position: relative;
}

.coming-soon-control.coming-soon-clickable {
  pointer-events: auto;
  cursor: not-allowed;
}

.coming-soon-badge {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  margin-left: 6px;
}

.empty-state {
  text-align: center;
  padding: 48px 24px;
  color: #6b7280;
}

.empty-state p {
  margin: 0 0 8px;
}

/* Mobile card layout for any admin table with data-label on cells */
@media (max-width: 768px) {
  .table-container .data-table thead {
    display: none;
  }

  .table-container .data-table tbody tr {
    display: block;
    margin-bottom: 12px;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-md);
    padding: 12px;
    background: #fff;
  }

  .table-container .data-table tbody td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
    border-bottom: 1px solid #f3f4f6;
    white-space: normal;
  }

  .table-container .data-table tbody td:last-child {
    border-bottom: none;
  }

  .table-container .data-table tbody td[data-label]::before {
    content: attr(data-label);
    font-weight: 600;
    color: var(--color-navy);
    flex-shrink: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/shared.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,mEAAmE;EACnE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,qCAAqC;IACrC,+BAA+B;IAC/B,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;EAChB;AACF","sourcesContent":["/* Shared admin UI patterns — import via index.css */\n\n.page-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--color-navy);\n  margin: 0 0 24px 0;\n}\n\n.page-controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.page-controls .search-bar,\n.page-controls .search-input {\n  flex: 1 1 200px;\n  min-width: 180px;\n  max-width: 320px;\n}\n\n.table-container {\n  background-color: #fff;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.data-table th,\n.data-table td {\n  padding: 14px 20px;\n  text-align: left;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.data-table th {\n  font-weight: 600;\n  color: var(--color-navy);\n  background-color: #fafafa;\n  white-space: nowrap;\n}\n\n.data-table td {\n  color: #374151;\n}\n\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.data-table td.text-nowrap {\n  white-space: nowrap;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n/* Consistent table action icons (react-icons) */\n.table-action-buttons {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.table-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--color-navy);\n  cursor: pointer;\n  transition: background-color 0.15s, color 0.15s, border-color 0.15s;\n  padding: 0;\n}\n\n.table-action-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n.table-action-btn:hover {\n  background-color: #f2f7ff;\n  border-color: #c7d8f5;\n}\n\n.table-action-btn.danger:hover {\n  background-color: #fee2e2;\n  border-color: #fca5a5;\n  color: #b91c1c;\n}\n\n.table-action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.table-action-btn.featured {\n  color: #f59e0b;\n  border-color: #fcd34d;\n  background-color: #fffbeb;\n}\n\n.table-action-btn.featured svg {\n  fill: #f59e0b;\n}\n\n.coming-soon-control {\n  opacity: 0.55;\n  cursor: not-allowed;\n  pointer-events: none;\n  position: relative;\n}\n\n.coming-soon-control.coming-soon-clickable {\n  pointer-events: auto;\n  cursor: not-allowed;\n}\n\n.coming-soon-badge {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n  margin-left: 6px;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 48px 24px;\n  color: #6b7280;\n}\n\n.empty-state p {\n  margin: 0 0 8px;\n}\n\n/* Mobile card layout for any admin table with data-label on cells */\n@media (max-width: 768px) {\n  .table-container .data-table thead {\n    display: none;\n  }\n\n  .table-container .data-table tbody tr {\n    display: block;\n    margin-bottom: 12px;\n    border: 1px solid var(--color-border);\n    border-radius: var(--radius-md);\n    padding: 12px;\n    background: #fff;\n  }\n\n  .table-container .data-table tbody td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 0;\n    border-bottom: 1px solid #f3f4f6;\n    white-space: normal;\n  }\n\n  .table-container .data-table tbody td:last-child {\n    border-bottom: none;\n  }\n\n  .table-container .data-table tbody td[data-label]::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: var(--color-navy);\n    flex-shrink: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
